import React, { useContext, useEffect, useState } from 'react';
import { useGlobalStore, ModalContext } from '../../components/contexts';
import ValidateService from '../../services/ValidateService';
import { useNavigate } from 'react-router-dom';
import { dbPost } from '../../apis/commonApi';
import { NumericFormat } from 'react-number-format';
import { isValidEmail } from '../../services/UtilService';
import { nlPost } from '../../apis/notLoginApi';

const EntInfo = () => {
  useEffect(() => {
    document.title = '기업 사용자 정보';
  }, []);
  const { store, updateStore } = useGlobalStore();
  const { modalService } = useContext(ModalContext);

  const validateService = new ValidateService(modalService);
  const navigate = useNavigate();
  const [dplChkBool, setDplChkBool] = useState(true);
  const [userEmlChg, setUserEmlChg] = useState(true);

  const [formData, setFormData] = useState({
    entSn: '',
    entId: '',
    entNm: '',
    entRprsv: '',
    entAddr: '',
    entDaddr: '',
    entZip: '',
    entTelno: '',
    entFxno: '',
    picNm: '',
    picTelno: '',
    picDept: '',
    picMblTelno: '',
    userType: '',
    instCd: '',
    instNm: '',
  });

  const instList = [
    { value: '해당없음', label: '해당없음' },
    { value: '인공지능그랜드ICT', label: '인공지능그랜드ICT' },
    { value: '부산경영자총협회', label: '부산경영자총협회' },
    { value: '부산기계공업협동조합', label: '부산기계공업협동조합' },
    { value: '부산벤처기업협회', label: '부산벤처기업협회' },
    { value: '한국선박수리공업협동조합', label: '한국선박수리공업협동조합' },
    {
      value: '한국재난안전사업기술연구조합',
      label: '한국재난안전사업기술연구조합',
    },
    { value: 'write', label: '직접입력' },
  ];

  useEffect(() => {
    if (store) {
      setFormData(prevFormData => ({
        ...prevFormData,
        entId: store.userId || '',
        userType: store.userType || '',
      }));
    }
  }, [store]);

  useEffect(() => {
    if (formData.entId) {
      getEntUserInfo();
    }
  }, [formData.entId]);

  const getEntUserInfo = () => {
    const url = '/member/getUserInfo.do';
    const param = {
      userId: formData.entId.replace(/\s+/g, ''),
      userType: formData.userType,
    };
    dbPost(url, param)
      .then(response => {
        let instCd = null;

        if (response.instNm !== null) {
          if (instList.some(item => item.value === response.instNm)) {
            instCd = response.instNm;
          } else {
            instCd = 'write';
          }
        }

        setFormData(prevFormData => ({
          ...prevFormData,
          entSn: response.entSn || '',
          entNm: response.entNm || '',
          entRprsv: response.entRprsv || '',
          entAddr: response.entAddr || '',
          entDaddr: response.entDaddr || '',
          entZip: response.entZip || '',
          entTelno: response.entTelno || '',
          entFxno: response.entFxno || '',
          picNm: response.picNm || '',
          picDept: response.picDept || '',
          picTelno: response.picTelno || '',
          picMblTelno: response.picMblTelno || '',
          picEml: response.picEml || '',
          picOrgnlEml: response.picEml || '',
          instNm: response.instNm || '',
          instCd: instCd,
        }));
      })
      .catch(error => {});
  };

  // 입력값 state에 저장
  const handleInputChange = e => {
    const { id, value } = e.target;
    if (id === 'picEml') {
      // 한글 입력 방지
      const isKorean = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/.test(value);
      if (isKorean) {
        return;
      }

      // 특수기호 제외 (@와 .은 허용)
      const isSpecialChar = /[^a-zA-Z0-9@.]/.test(value);
      if (isSpecialChar) {
        return;
      }

      setUserEmlChg(false);
      setDplChkBool(false);
    }
    setFormData(prevFormData => ({
      ...prevFormData,
      [id]: value,
    }));
  };

  // 카카오 주소 검색
  const handleAddressSearch = () => {
    new daum.Postcode({
      oncomplete: function (data) {
        setFormData(prevFormData => ({
          ...prevFormData,
          entAddr: data.roadAddress,
          entZip: data.zonecode,
        }));
      },
    }).open();
  };

  const beforeUpdate = async () => {
    const validationRules = {
      entNm: { presence: true },
      entRprsv: { presence: true },
      entAddr: { presence: true },
      entDaddr: { presence: true },
      entZip: { presence: true },
      entTelno: { presence: true },
      entFxno: { presence: true },
      picNm: { presence: true },
      picDept: { presence: true },
      picTelno: { presence: true },
      picMblTelno: { presence: true },
      picEml: { presence: true, email: true },
    };

    if (formData.instCd === 'write') {
      validationRules.instNm = { presence: true };
    }

    const altKey = {
      entNm: '회사명',
      entRprsv: '대표자',
      entAddr: '주소',
      entDaddr: '상세주소',
      entZip: '우편번호',
      entTelno: '전화번호',
      entFxno: '팩스번호',
      picNm: '담당자명',
      picDept: '담당부서',
      picTelno: '전화번호',
      picMblTelno: '휴대전화',
      picEml: '담당자 이메일 주소',
      instNm: '기관(협회)',
    };

    if (
      await validateService.validateJsCall(formData, validationRules, altKey)
    ) {
      return;
    }
    if (dplChkBool == true && userEmlChg == true) {
      updateEntUserInfo();
    } else {
      modalService.noticeAlert('이메일 중복확인을 해주세요.', () => {});
      return;
    }
  };

  const updateEntUserInfo = () => {
    const url = '/member/updateUserInfo.do';
    const param = {
      entNm: formData.entNm,
      entRprsv: formData.entRprsv,
      entAddr: formData.entAddr,
      entDaddr: formData.entDaddr,
      entZip: formData.entZip,
      entTelno: formData.entTelno,
      entFxno: formData.entFxno,
      picNm: formData.picNm,
      picDept: formData.picDept,
      picTelno: formData.picTelno,
      picMblTelno: formData.picMblTelno,
      picEml: formData.picEml,
      entSn: formData.entSn,
      userType: formData.userType,
      picOrgnlEml: formData.picEml,
      instCd: formData.instCd,
      instNm: formData.instNm,
    };

    if (param.userId != '' && param.userType != '') {
      dbPost(url, param)
        .then(response => {
          if (response instanceof Error) {
            this.modalService.errorAlert(
              '데이터 처리중 에러가 발생하였습니다',
              () => {}
            );
          } else {
            if (response == true) {
            } else if (response == false) {
            }
          }
          modalService.successAlert('사용자 정보를 수정하였습니다.', () => {
            navigate('/');
          });
        })
        .catch(error => {});
    }
  };

  const handleValidateAndCheck = async () => {
    const isValid = await fnValidateEmail(formData.picEml);
    if (isValid) {
      emlDplChk();
    }
  };

  const emlDplChk = () => {
    const url = '/member/duplicateUserEmlChk.do';
    const param = {
      userEml: formData.picEml,
    };
    nlPost(url, param)
      .then(response => {
        if (response instanceof Error) {
          this.modalService.errorAlert(
            '데이터 처리중 에러가 발생하였습니다',
            () => {}
          );
        } else if (formData.picEml == formData.picOrgnlEml) {
          setDplChkBool(true);
          setUserEmlChg(true);
          modalService.successAlert('사용 가능한 이메일 주소입니다.', () => {
            return;
          });
        } else {
          if (response == true) {
            setDplChkBool(true);
            setUserEmlChg(true);
            modalService.successAlert('사용 가능한 이메일 주소입니다.');
            setFormData(prevFormData => ({ ...prevFormData, userEml: '' }));
          } else if (response == false) {
            setDplChkBool(false);
            modalService.errorAlert('사용 불가능한 이메일 주소입니다.');
          }
        }
      })
      .catch(error => {});
  };

  const fnValidateEmail = async email => {
    if (!isValidEmail(email)) {
      modalService.errorAlert('이메일 형식이 아닙니다.');
      setFormData(prevFormData => ({ ...prevFormData, userEml: '' }));
      return false;
    } else {
      return true;
    }
  };

  const withDrawal = () => {
    navigate('/member/userInfo/entWithdrawal');
  };

  return (
    <>
      {/* 페이지 타이틀 영역 */}
      <div className="page-title-wrap" data-type="responsive">
        <h2 className="h-tit">사용자 정보</h2>
      </div>
      {/* //페이지 타이틀 영역 */}

      <h3 className="content-tit">사용자 정보</h3>
      <p className="text-gray-70">
        사용자 정보를 확인하고 수정하실 수 있습니다.
      </p>
      <p className="tbl-msg gap-sm">
        <em className="star-require">*</em> 표시는 필수 입력 사항입니다.
      </p>
      <div className="txt-box bg-white">
        <h4>기업정보</h4>
        <fieldset>
          <legend>기업정보 입력</legend>
          <div className="fieldset">
            <div className="form-group">
              <div className="form-title">
                <label>
                  아이디<em className="star-require">*</em>
                </label>
              </div>
              <div className="form-conts" style={{ width: '64.4%' }}>
                <div className="input-group">
                  <div className="box-sec">
                    <h5 className="box-tit2">
                      <label>{formData.entId || ''}</label>
                    </h5>
                  </div>
                </div>
              </div>
            </div>
            <div className="input-group">
              <div className="form-group">
                <div className="form-title">
                  <label htmlFor="entNm">
                    기업명<em className="star-require">*</em>
                  </label>
                </div>
                <div className="form-conts">
                  <input
                    type="text"
                    id="entNm"
                    value={formData.entNm || ''}
                    onChange={handleInputChange}
                    className="form-control"
                    maxLength={20}
                    aria-labelledby="entNm"
                  />
                </div>
              </div>
              <div className="form-group">
                <div className="form-title">
                  <label htmlFor="entRprsv">
                    대표자<em className="star-require">*</em>
                  </label>
                </div>
                <div className="form-conts">
                  <input
                    type="text"
                    className="form-control"
                    id="entRprsv"
                    value={formData.entRprsv || ''}
                    onChange={handleInputChange}
                    maxLength={20}
                    aria-labelledby="entRprsv"
                  />
                </div>
              </div>
            </div>
            <div className="input-group">
              <div className="form-group">
                <div className="form-title">
                  <label htmlFor="inst">기관(협회)</label>
                </div>
                <div className={`form-conts`}>
                  <div className="input-group">
                    <label className="hidden-label" htmlFor="instCd">
                      라벨
                    </label>
                    <select
                      className="form-select"
                      name="instCd"
                      value={formData.instCd}
                      onChange={handleInputChange}
                      id="instCd"
                    >
                      {instList.map((item, index) => {
                        return (
                          <option key={index} value={item.value}>
                            {item.label}
                          </option>
                        );
                      })}
                    </select>
                    <label className="hidden-label" htmlFor="instNm">
                      라벨
                    </label>
                    <input
                      className="form-control"
                      id="instNm"
                      type="text"
                      placeholder="00협회, 00조합"
                      value={
                        formData.instCd === 'write'
                          ? formData.instNm
                          : formData.instCd
                      }
                      onChange={handleInputChange}
                      readOnly={formData.instCd === 'write' ? false : true}
                      maxLength={33}
                      aria-labelledby="taskNmLbl"
                    />
                  </div>
                </div>
              </div>
            </div>
            {/* 아랫쪽 주소와 이 셋중에 적당한 걸로.. */}
            <div className="form-group">
              <div className="form-title">
                주소<em className="star-require">*</em>
              </div>
              <div className="form-conts">
                <div className="input-group" style={{ width: '68.37%' }}>
                  <label className="hidden-label" htmlFor="entAddr">
                    라벨
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="entAddr"
                    value={formData.entAddr || ''}
                    onChange={handleInputChange}
                    maxLength={200}
                    style={{ maxWidth: '406px' }}
                    readOnly
                    aria-labelledby="entAddr"
                  />

                  <button
                    type="button"
                    className="btn secondary"
                    onClick={handleAddressSearch}
                  >
                    주소 찾기
                  </button>
                </div>
                <div className="input-group">
                  <label className="hidden-label" htmlFor="entDaddr">
                    라벨
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="entDaddr"
                    value={formData.entDaddr || ''}
                    onChange={handleInputChange}
                    maxLength={200}
                    aria-labelledby="entDaddr"
                  />
                  <label className="hidden-label" htmlFor="entZip">
                    라벨
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="entZip"
                    value={formData.entZip || ''}
                    onChange={handleInputChange}
                    readOnly
                    maxLength={5}
                    aria-labelledby="entZip"
                  />
                </div>
              </div>
            </div>
            <div className="input-group">
              <div className="form-group">
                <div className="form-title">
                  <label htmlFor="entTelno">
                    전화번호<em className="star-require">*</em>
                  </label>
                </div>
                <div className="form-conts">
                  <NumericFormat
                    type="text"
                    id="entTelno"
                    className="form-control"
                    value={formData.entTelno || ''}
                    onChange={handleInputChange}
                    thousandSeparator={false}
                    maxLength={11}
                    allowLeadingZeros={true}
                    allowNegative={false}
                    aria-labelledby="entTelno"
                  />
                </div>
              </div>
              <div className="form-group">
                <div className="form-title">
                  <label htmlFor="entFxno">팩스번호</label>
                </div>
                <div className="form-conts">
                  <NumericFormat
                    type="text"
                    id="entFxno"
                    className="form-control"
                    value={formData.entFxno || ''}
                    onChange={handleInputChange}
                    thousandSeparator={false}
                    maxLength={11}
                    allowLeadingZeros={true}
                    allowNegative={false}
                    aria-labelledby="entFxno"
                  />
                </div>
              </div>
            </div>
          </div>
        </fieldset>
        <h4 className="gap-md">담당자 정보</h4>
        <fieldset>
          <legend>담당자 정보 입력</legend>
          <div className="fieldset">
            <div className="input-group">
              <div className="form-group">
                <div className="form-title">
                  <label htmlFor="picNm">
                    담당자명<em className="star-require">*</em>
                  </label>
                </div>
                <div className="form-conts">
                  <input
                    type="text"
                    className="form-control"
                    id="picNm"
                    value={formData.picNm || ''}
                    onChange={handleInputChange}
                    maxLength={20}
                    aria-labelledby="picNm"
                  />
                </div>
              </div>
              <div className="form-group">
                <div className="form-title">
                  <label htmlFor="picDept">
                    담당부서<em className="star-require">*</em>
                  </label>
                </div>
                <div className="form-conts">
                  <input
                    type="text"
                    className="form-control"
                    id="picDept"
                    value={formData.picDept || ''}
                    onChange={handleInputChange}
                    maxLength={20}
                    aria-labelledby="picDept"
                  />
                </div>
              </div>
            </div>
            <div className="input-group">
              <div className="form-group">
                <div className="form-title">
                  <label htmlFor="picTelno">
                    전화번호<em className="star-require">*</em>
                  </label>
                </div>
                <div className="form-conts">
                  <NumericFormat
                    type="text"
                    id="picTelno"
                    className="form-control"
                    value={formData.picTelno || ''}
                    onChange={handleInputChange}
                    thousandSeparator={false}
                    maxLength={11}
                    allowLeadingZeros={true}
                    allowNegative={false}
                    aria-labelledby="picTelno"
                  />
                </div>
              </div>
              <div className="form-group">
                <div className="form-title">
                  <label htmlFor="picMblTelno">
                    휴대전화<em className="star-require">*</em>
                  </label>
                </div>
                <div className="form-conts">
                  <NumericFormat
                    type="text"
                    id="picMblTelno"
                    className="form-control"
                    value={formData.picMblTelno || ''}
                    onChange={handleInputChange}
                    thousandSeparator={false}
                    allowNegative={false}
                    maxLength={11}
                    allowLeadingZeros={true}
                    aria-labelledby="picMblTelno"
                  />
                </div>
              </div>
            </div>
            <div className="input-group">
              <div className="form-group">
                <div className="form-title">
                  <label htmlFor="picEml">
                    담당자 이메일 주소<em className="star-require">*</em>
                  </label>
                </div>
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control"
                    id="picEml"
                    value={formData.picEml || ''}
                    onChange={handleInputChange}
                    maxLength={50}
                    aria-labelledby="picEml"
                  />{' '}
                  <button
                    type="button"
                    className="btn secondary"
                    onClick={() => {
                      handleValidateAndCheck();
                    }}
                  >
                    중복검사
                  </button>
                </div>
              </div>
            </div>
          </div>
        </fieldset>
      </div>
      <div className="page-btn-wrap both">
        <button type="button" className="btn xlg disband" onClick={withDrawal}>
          사용자탈퇴
        </button>
        <button
          type="button"
          className="btn xlg primary"
          onClick={beforeUpdate}
        >
          변경내용 저장
        </button>
      </div>
    </>
  );
};

export default EntInfo;
